import { ChatState } from "PFApp/components/chat/chat_states";
import { ActionIcon } from "PFComponents/action_icon";

type ChatDropdownToggleIconProps = {
  chatState: ChatState;
  dropdownOpen: boolean;
  onToggleDropdown: (open: boolean) => void;
};

export const ChatDropdownToggleIcon = ({
  chatState,
  dropdownOpen,
  onToggleDropdown
}: ChatDropdownToggleIconProps) => {
  if (dropdownOpen) {
    return (
      <ActionIcon name="menu-horizontal" size="sm" onClick={() => onToggleDropdown(false)} disableHover />
    );
  }

  const onClick = chatState === ChatState.Loading ? undefined : () => onToggleDropdown(true);

  return <ActionIcon name="menu-horizontal" size="sm" onClick={onClick} disableHover />;
};
